import React from 'react';

export default function EditIcon({
	title,
	onClick,
	editKey,
	className = 'btn-link btn-unstyled',
	editEl = <i className="fa fa-pencil-square-o padding-x-xs"></i>
}) {
	const handleClick = () => {
		onClick(editKey);
	};

	return (
		<button type="button" title={`Edit ${title ?? ''}`} className={className} onClick={handleClick}>
			{editEl}
		</button>
	);
}
